var map = {
	"./avatars/avatar-aaron-powell/avatar-aaron-powell.jpg": 25931,
	"./avatars/avatar-aaron-powell/avatar-aaron-powell.webp": 77219,
	"./avatars/avatar-alex-allan/avatar-alex-allan.jpg": 38287,
	"./avatars/avatar-alex-allan/avatar-alex-allan.webp": 51118,
	"./avatars/avatar-alex-allan2/avatar-alex-allan2.jpg": 53592,
	"./avatars/avatar-alex-allan2/avatar-alex-allan2.webp": 90196,
	"./avatars/avatar-andy-gray/avatar-andy-gray.jpg": 56776,
	"./avatars/avatar-andy-gray/avatar-andy-gray.webp": 35443,
	"./avatars/avatar-andy-gray2/avatar-andy-gray2.png": 13695,
	"./avatars/avatar-andy-gray2/avatar-andy-gray2.webp": 60179,
	"./avatars/avatar-andy-gray3/avatar-andy-gray3.jpg": 60259,
	"./avatars/avatar-andy-gray3/avatar-andy-gray3.webp": 29551,
	"./avatars/avatar-barbara-johnson/avatar-barbara-johnson.jpg": 59046,
	"./avatars/avatar-barbara-johnson/avatar-barbara-johnson.webp": 91174,
	"./avatars/avatar-barbara-johnson2/avatar-barbara-johnson2.jpg": 29529,
	"./avatars/avatar-barbara-johnson2/avatar-barbara-johnson2.webp": 16249,
	"./avatars/avatar-gartner/avatar-gartner.jpg": 47112,
	"./avatars/avatar-gartner/avatar-gartner.webp": 11597,
	"./avatars/avatar-howard-cooke/avatar-howard-cooke.jpg": 30329,
	"./avatars/avatar-howard-cooke/avatar-howard-cooke.webp": 52799,
	"./avatars/avatar-jaclyn-de-jesus/avatar-jaclyn-de-jesus.jpg": 96399,
	"./avatars/avatar-jaclyn-de-jesus/avatar-jaclyn-de-jesus.webp": 51167,
	"./avatars/avatar-kortical-team/avatar-kortical-team.png": 82458,
	"./avatars/avatar-kortical-team/avatar-kortical-team.webp": 74307,
	"./avatars/avatar-kortical-team1/avatar-kortical-team1--mobile.jpg": 19891,
	"./avatars/avatar-kortical-team1/avatar-kortical-team1--mobile.webp": 15925,
	"./avatars/avatar-kortical-team1/avatar-kortical-team1.jpg": 7394,
	"./avatars/avatar-kortical-team1/avatar-kortical-team1.webp": 53759,
	"./avatars/avatar-kortical-team2/avatar-kortical-team2--mobile.jpg": 63054,
	"./avatars/avatar-kortical-team2/avatar-kortical-team2--mobile.webp": 22650,
	"./avatars/avatar-kortical-team2/avatar-kortical-team2.jpg": 79258,
	"./avatars/avatar-kortical-team2/avatar-kortical-team2.webp": 88094,
	"./avatars/avatar-kortical-team3/avatar-kortical-team3--mobile.jpg": 47042,
	"./avatars/avatar-kortical-team3/avatar-kortical-team3--mobile.webp": 9506,
	"./avatars/avatar-kortical-team3/avatar-kortical-team3.jpg": 71065,
	"./avatars/avatar-kortical-team3/avatar-kortical-team3.webp": 10274,
	"./avatars/avatar-matt-hancock/avatar-matt-hancock.jpg": 25805,
	"./avatars/avatar-matt-hancock/avatar-matt-hancock.webp": 59915,
	"./avatars/avatar-simon-james/avatar-simon-james.jpeg": 79409,
	"./avatars/avatar-simon-james/avatar-simon-james.webp": 56883,
	"./clients/bbc.svg": 80631,
	"./clients/bt-color-new.svg": 1673,
	"./clients/bt-color.svg": 65174,
	"./clients/capita-color.svg": 44042,
	"./clients/cs/alt-bank.svg": 58151,
	"./clients/cs/alt-big-4.svg": 86849,
	"./clients/cs/alt-bt.svg": 85649,
	"./clients/cs/alt-global-retailer.svg": 76649,
	"./clients/cs/alt-gsc.svg": 88394,
	"./clients/cs/alt-nhs.svg": 38975,
	"./clients/cs/alt-pub-sap.svg": 90779,
	"./clients/cs/api-group.svg": 38018,
	"./clients/cs/api.svg": 46212,
	"./clients/cs/bank.svg": 67820,
	"./clients/cs/bt.svg": 23300,
	"./clients/cs/deloitte.svg": 4299,
	"./clients/cs/flydocs.svg": 71351,
	"./clients/cs/ford.svg": 2386,
	"./clients/cs/global-retailer.svg": 53710,
	"./clients/cs/gsc.svg": 59848,
	"./clients/cs/hcuk.svg": 26529,
	"./clients/cs/innovator-international.svg": 30920,
	"./clients/cs/nhs.svg": 48716,
	"./clients/cs/pub-sap.svg": 78885,
	"./clients/cs/reed.svg": 60579,
	"./clients/cs/tac.svg": 98594,
	"./clients/cs/zappi.svg": 32574,
	"./clients/ct.svg": 97043,
	"./clients/deloitte-color.svg": 46003,
	"./clients/fca-color.svg": 95381,
	"./clients/fca.svg": 93421,
	"./clients/flydocs.svg": 77342,
	"./clients/ford-color.svg": 1748,
	"./clients/forrester.svg": 14021,
	"./clients/mbnl.svg": 50138,
	"./clients/nhs-color.svg": 24540,
	"./clients/nhs-logo/nhs-logo.png": 26027,
	"./clients/nhs-logo/nhs-logo.webp": 91791,
	"./clients/nhs.svg": 43815,
	"./clients/publicis-sapient-logo.svg": 84298,
	"./clients/publicis-sapient-new.svg": 8093,
	"./clients/santander-color.svg": 82647,
	"./clients/tac-color.svg": 49945,
	"./clients/zappi-color.svg": 68196,
	"./competitors/aws-logo/aws-logo.png": 70087,
	"./competitors/aws-logo/aws-logo.webp": 93470,
	"./competitors/dataRobot-logo/dataRobot-logo.png": 35130,
	"./competitors/dataRobot-logo/dataRobot-logo.webp": 95420,
	"./competitors/google-logo/google-logo.png": 84897,
	"./competitors/google-logo/google-logo.webp": 33849,
	"./competitors/h2o-logo/h2o-logo.png": 57790,
	"./competitors/h2o-logo/h2o-logo.webp": 6039,
	"./competitors/microsoft-logo/microsoft-logo.png": 6596,
	"./competitors/microsoft-logo/microsoft-logo.webp": 89803,
	"./competitors/schroders-logo/schroders-logo.png": 80929,
	"./competitors/schroders-logo/schroders-logo.webp": 84112,
	"./content/about-us-hero/about-us-hero--mobile.jpg": 96286,
	"./content/about-us-hero/about-us-hero--mobile.webp": 44901,
	"./content/about-us-hero/about-us-hero.jpg": 92078,
	"./content/about-us-hero/about-us-hero.webp": 73058,
	"./content/about-us-security/about-us-security--mobile.jpg": 36129,
	"./content/about-us-security/about-us-security--mobile.webp": 65460,
	"./content/about-us-security/about-us-security.jpg": 87569,
	"./content/about-us-security/about-us-security.webp": 17118,
	"./content/about-us-security1/about-us-security1--mobile.jpg": 63080,
	"./content/about-us-security1/about-us-security1--mobile.webp": 16898,
	"./content/about-us-security1/about-us-security1.jpg": 31840,
	"./content/about-us-security1/about-us-security1.webp": 68136,
	"./content/about-us-sustainability/about-us-sustainability--mobile.jpg": 85236,
	"./content/about-us-sustainability/about-us-sustainability--mobile.webp": 64411,
	"./content/about-us-sustainability/about-us-sustainability.jpg": 78824,
	"./content/about-us-sustainability/about-us-sustainability.webp": 97628,
	"./content/ai-consultancy-1/ai-consultancy-1--mobile.png": 44771,
	"./content/ai-consultancy-1/ai-consultancy-1--mobile.webp": 49902,
	"./content/ai-consultancy-1/ai-consultancy-1.png": 26810,
	"./content/ai-consultancy-1/ai-consultancy-1.webp": 64542,
	"./content/ai-consultancy-2/ai-consultancy-2.png": 92185,
	"./content/ai-consultancy-2/ai-consultancy-2.webp": 59233,
	"./content/ai-marketing-1/ai-marketing-1--mobile.png": 33876,
	"./content/ai-marketing-1/ai-marketing-1--mobile.webp": 31935,
	"./content/ai-marketing-1/ai-marketing-1.png": 22089,
	"./content/ai-marketing-1/ai-marketing-1.webp": 77110,
	"./content/ai-marketing-3/ai-marketing-3--mobile.png": 92881,
	"./content/ai-marketing-3/ai-marketing-3--mobile.webp": 29811,
	"./content/ai-marketing-3/ai-marketing-3.png": 52220,
	"./content/ai-marketing-3/ai-marketing-3.webp": 6327,
	"./content/ai-marketing-4/ai-marketing-4--mobile.png": 95216,
	"./content/ai-marketing-4/ai-marketing-4--mobile.webp": 19556,
	"./content/ai-marketing-4/ai-marketing-4.png": 34852,
	"./content/ai-marketing-4/ai-marketing-4.webp": 69112,
	"./content/ai-marketing-5/ai-marketing-5--mobile.png": 15884,
	"./content/ai-marketing-5/ai-marketing-5--mobile.webp": 22357,
	"./content/ai-marketing-5/ai-marketing-5.png": 19926,
	"./content/ai-marketing-5/ai-marketing-5.webp": 60147,
	"./content/ai-marketing-6/ai-marketing-6--mobile.png": 59472,
	"./content/ai-marketing-6/ai-marketing-6--mobile.webp": 92310,
	"./content/ai-marketing-6/ai-marketing-6.png": 63032,
	"./content/ai-marketing-6/ai-marketing-6.webp": 15614,
	"./content/ai-marketing-7/ai-marketing-7--mobile.jpg": 33994,
	"./content/ai-marketing-7/ai-marketing-7--mobile.webp": 60099,
	"./content/ai-marketing-7/ai-marketing-7.jpg": 25076,
	"./content/ai-marketing-7/ai-marketing-7.webp": 32213,
	"./content/ai-marketing-8/ai-marketing-8--mobile.png": 39934,
	"./content/ai-marketing-8/ai-marketing-8--mobile.webp": 36528,
	"./content/ai-marketing-8/ai-marketing-8.png": 74917,
	"./content/ai-marketing-8/ai-marketing-8.webp": 73158,
	"./content/ai-solutions-with-roadmap1/ai-solutions-with-roadmap1--mobile.jpg": 88880,
	"./content/ai-solutions-with-roadmap1/ai-solutions-with-roadmap1--mobile.webp": 39329,
	"./content/ai-solutions-with-roadmap1/ai-solutions-with-roadmap1.jpg": 39264,
	"./content/ai-solutions-with-roadmap1/ai-solutions-with-roadmap1.webp": 75416,
	"./content/ai-solutions-with-roadmap2/ai-solutions-with-roadmap2--mobile.jpg": 69841,
	"./content/ai-solutions-with-roadmap2/ai-solutions-with-roadmap2--mobile.webp": 91443,
	"./content/ai-solutions-with-roadmap2/ai-solutions-with-roadmap2.jpg": 43585,
	"./content/ai-solutions-with-roadmap2/ai-solutions-with-roadmap2.webp": 27712,
	"./content/ai-solutions-with-roadmap3/ai-solutions-with-roadmap3--mobile.jpg": 45689,
	"./content/ai-solutions-with-roadmap3/ai-solutions-with-roadmap3--mobile.webp": 69503,
	"./content/ai-solutions-with-roadmap3/ai-solutions-with-roadmap3.jpg": 9558,
	"./content/ai-solutions-with-roadmap3/ai-solutions-with-roadmap3.webp": 923,
	"./content/ai-solutions-with-roadmap4/ai-solutions-with-roadmap4--mobile.jpg": 77341,
	"./content/ai-solutions-with-roadmap4/ai-solutions-with-roadmap4--mobile.webp": 76614,
	"./content/ai-solutions-with-roadmap4/ai-solutions-with-roadmap4.jpg": 23275,
	"./content/ai-solutions-with-roadmap4/ai-solutions-with-roadmap4.webp": 70918,
	"./content/ai-solutions-with-roadmap5/ai-solutions-with-roadmap5.jpg": 72079,
	"./content/ai-solutions-with-roadmap5/ai-solutions-with-roadmap5.webp": 35653,
	"./content/app-features-1/app-features-1--mobile.png": 33875,
	"./content/app-features-1/app-features-1--mobile.webp": 27050,
	"./content/app-features-1/app-features-1.png": 66818,
	"./content/app-features-1/app-features-1.webp": 73146,
	"./content/app-features-2/app-features-2--mobile.png": 85697,
	"./content/app-features-2/app-features-2--mobile.webp": 68812,
	"./content/app-features-2/app-features-2.png": 99055,
	"./content/app-features-2/app-features-2.webp": 39765,
	"./content/app-features-3/app-features-3--mobile.png": 99427,
	"./content/app-features-3/app-features-3--mobile.webp": 44683,
	"./content/app-features-3/app-features-3.png": 62161,
	"./content/app-features-3/app-features-3.webp": 11259,
	"./content/app-features-4/app-features-4--mobile.png": 42166,
	"./content/app-features-4/app-features-4--mobile.webp": 898,
	"./content/app-features-4/app-features-4.png": 28916,
	"./content/app-features-4/app-features-4.webp": 34515,
	"./content/app-features-5/app-features-5--mobile.png": 26227,
	"./content/app-features-5/app-features-5--mobile.webp": 48146,
	"./content/app-features-5/app-features-5.png": 66034,
	"./content/app-features-5/app-features-5.webp": 53513,
	"./content/app-features-6/app-features-6--mobile.png": 26965,
	"./content/app-features-6/app-features-6--mobile.webp": 93395,
	"./content/app-features-6/app-features-6.png": 36877,
	"./content/app-features-6/app-features-6.webp": 86031,
	"./content/art-innovation/art-innovation--mobile.png": 26402,
	"./content/art-innovation/art-innovation--mobile.webp": 97283,
	"./content/art-innovation/art-innovation.png": 56229,
	"./content/art-innovation/art-innovation.webp": 67251,
	"./content/avatar-andy-gray3/avatar-andy-gray3.jpg": 62301,
	"./content/avatar-andy-gray3/avatar-andy-gray3.webp": 24366,
	"./content/bg-abandoned-robot/bg-abandoned-robot--mobile.jpg": 33377,
	"./content/bg-abandoned-robot/bg-abandoned-robot--mobile.webp": 79111,
	"./content/bg-abandoned-robot/bg-abandoned-robot.jpg": 81042,
	"./content/bg-abandoned-robot/bg-abandoned-robot.webp": 48051,
	"./content/bg-ai-as-a-service/bg-ai-as-a-service--mobile.jpg": 53462,
	"./content/bg-ai-as-a-service/bg-ai-as-a-service--mobile.webp": 52422,
	"./content/bg-ai-as-a-service/bg-ai-as-a-service.jpg": 25338,
	"./content/bg-ai-as-a-service/bg-ai-as-a-service.webp": 8305,
	"./content/bg-ai-solution-with-roadmap/bg-ai-solution-with-roadmap--mobile.jpg": 28866,
	"./content/bg-ai-solution-with-roadmap/bg-ai-solution-with-roadmap--mobile.webp": 45990,
	"./content/bg-ai-solution-with-roadmap/bg-ai-solution-with-roadmap.jpg": 70432,
	"./content/bg-ai-solution-with-roadmap/bg-ai-solution-with-roadmap.webp": 31856,
	"./content/bg-api/bg-api.jpg": 12671,
	"./content/bg-api/bg-api.webp": 96901,
	"./content/bg-app/bg-app--mobile.jpg": 48454,
	"./content/bg-app/bg-app--mobile.webp": 56243,
	"./content/bg-app/bg-app.jpg": 58932,
	"./content/bg-app/bg-app.webp": 3451,
	"./content/bg-blood/bg-blood--mobile.jpg": 66493,
	"./content/bg-blood/bg-blood--mobile.webp": 86133,
	"./content/bg-blood/bg-blood.jpg": 86135,
	"./content/bg-blood/bg-blood.webp": 22499,
	"./content/bg-boxes/bg-boxes--mobile.jpg": 80327,
	"./content/bg-boxes/bg-boxes--mobile.webp": 83468,
	"./content/bg-boxes/bg-boxes.jpg": 3856,
	"./content/bg-boxes/bg-boxes.webp": 38824,
	"./content/bg-business-dilemma/bg-business-dilemma.png": 73508,
	"./content/bg-business-dilemma/bg-business-dilemma.webp": 43847,
	"./content/bg-clocks/bg-clocks--mobile.jpg": 4527,
	"./content/bg-clocks/bg-clocks--mobile.webp": 71155,
	"./content/bg-clocks/bg-clocks.jpg": 13878,
	"./content/bg-clocks/bg-clocks.webp": 21757,
	"./content/bg-credit-score/bg-credit-score--mobile.jpg": 12629,
	"./content/bg-credit-score/bg-credit-score--mobile.webp": 51585,
	"./content/bg-credit-score/bg-credit-score.jpg": 98331,
	"./content/bg-credit-score/bg-credit-score.webp": 91193,
	"./content/bg-cs-zappi/bg-cs-zappi--mobile.jpg": 27158,
	"./content/bg-cs-zappi/bg-cs-zappi--mobile.webp": 99290,
	"./content/bg-cs-zappi/bg-cs-zappi.jpg": 83349,
	"./content/bg-cs-zappi/bg-cs-zappi.webp": 55457,
	"./content/bg-doctor/bg-doctor--mobile.jpg": 59054,
	"./content/bg-doctor/bg-doctor--mobile.webp": 94702,
	"./content/bg-doctor/bg-doctor.jpg": 74868,
	"./content/bg-doctor/bg-doctor.webp": 31601,
	"./content/bg-email-automation/bg-email-automation--mobile.jpg": 92193,
	"./content/bg-email-automation/bg-email-automation--mobile.webp": 74269,
	"./content/bg-email-automation/bg-email-automation.jpg": 97217,
	"./content/bg-email-automation/bg-email-automation.webp": 3397,
	"./content/bg-finance/bg-finance--mobile.jpg": 3701,
	"./content/bg-finance/bg-finance--mobile.webp": 96126,
	"./content/bg-finance/bg-finance.jpg": 58736,
	"./content/bg-finance/bg-finance.webp": 82405,
	"./content/bg-flydocs/bg-flydocs.jpg": 67083,
	"./content/bg-flydocs/bg-flydocs.webp": 97429,
	"./content/bg-ford/bg-ford--mobile.jpeg": 57098,
	"./content/bg-ford/bg-ford--mobile.webp": 61591,
	"./content/bg-ford/bg-ford.jpeg": 47522,
	"./content/bg-ford/bg-ford.webp": 86909,
	"./content/bg-hcuk/bg-hcuk.jpg": 82293,
	"./content/bg-hcuk/bg-hcuk.webp": 6122,
	"./content/bg-innovation/bg-innovation--mobile.jpg": 17358,
	"./content/bg-innovation/bg-innovation--mobile.webp": 17374,
	"./content/bg-innovation/bg-innovation.jpg": 59873,
	"./content/bg-innovation/bg-innovation.webp": 91659,
	"./content/bg-k-platform-sharing/bg-k-platform-sharing--mobile.jpg": 72462,
	"./content/bg-k-platform-sharing/bg-k-platform-sharing--mobile.webp": 68157,
	"./content/bg-k-platform-sharing/bg-k-platform-sharing.jpg": 80305,
	"./content/bg-k-platform-sharing/bg-k-platform-sharing.webp": 72827,
	"./content/bg-notes/bg-notes--mobile.jpg": 28370,
	"./content/bg-notes/bg-notes--mobile.webp": 63607,
	"./content/bg-notes/bg-notes.jpg": 65498,
	"./content/bg-notes/bg-notes.webp": 10706,
	"./content/bg-numbers/bg-numbers--mobile.jpg": 16615,
	"./content/bg-numbers/bg-numbers--mobile.webp": 87627,
	"./content/bg-numbers/bg-numbers.jpg": 40961,
	"./content/bg-numbers/bg-numbers.webp": 10360,
	"./content/bg-pandas-profiling/bg-pandas-profiling--mobile.jpg": 56169,
	"./content/bg-pandas-profiling/bg-pandas-profiling--mobile.webp": 43301,
	"./content/bg-pandas-profiling/bg-pandas-profiling.jpg": 81800,
	"./content/bg-pandas-profiling/bg-pandas-profiling.webp": 37897,
	"./content/bg-schroders/bg-schroders.jpg": 11913,
	"./content/bg-schroders/bg-schroders.webp": 25107,
	"./content/bg-spacex/bg-spacex--mobile.jpg": 61231,
	"./content/bg-spacex/bg-spacex--mobile.webp": 53448,
	"./content/bg-spacex/bg-spacex.jpg": 60261,
	"./content/bg-spacex/bg-spacex.webp": 28778,
	"./content/bg-superhuman-ai/bg-superhuman-ai--mobile.jpg": 77690,
	"./content/bg-superhuman-ai/bg-superhuman-ai--mobile.webp": 91002,
	"./content/bg-superhuman-ai/bg-superhuman-ai.jpg": 98271,
	"./content/bg-superhuman-ai/bg-superhuman-ai.webp": 32669,
	"./content/bg-tac/bg-tac--mobile.jpg": 61270,
	"./content/bg-tac/bg-tac--mobile.webp": 13696,
	"./content/bg-tac/bg-tac.jpg": 8377,
	"./content/bg-tac/bg-tac.webp": 82194,
	"./content/bg-tax/bg-tax--mobile.jpg": 60268,
	"./content/bg-tax/bg-tax--mobile.webp": 73896,
	"./content/bg-tax/bg-tax.jpg": 72581,
	"./content/bg-tax/bg-tax.webp": 95740,
	"./content/bg-tech-nation-2/bg-tech-nation-2--mobile.png": 59155,
	"./content/bg-tech-nation-2/bg-tech-nation-2--mobile.webp": 59867,
	"./content/bg-tech-nation-2/bg-tech-nation-2.png": 41861,
	"./content/bg-tech-nation-2/bg-tech-nation-2.webp": 2608,
	"./content/bg-tech-nation/bg-tech-nation--mobile.png": 42045,
	"./content/bg-tech-nation/bg-tech-nation--mobile.webp": 51127,
	"./content/bg-tech-nation/bg-tech-nation.png": 79775,
	"./content/bg-tech-nation/bg-tech-nation.webp": 41343,
	"./content/bg-tower/bg-tower--mobile.jpg": 67793,
	"./content/bg-tower/bg-tower--mobile.webp": 71724,
	"./content/bg-tower/bg-tower.jpg": 87729,
	"./content/bg-tower/bg-tower.webp": 29766,
	"./content/bg-what-is-ml/bg-what-is-ml--mobile.jpg": 22755,
	"./content/bg-what-is-ml/bg-what-is-ml--mobile.webp": 273,
	"./content/bg-what-is-ml/bg-what-is-ml.jpg": 77573,
	"./content/bg-what-is-ml/bg-what-is-ml.webp": 4836,
	"./content/bg-wires/bg-wires--mobile.jpg": 45734,
	"./content/bg-wires/bg-wires--mobile.webp": 27305,
	"./content/bg-wires/bg-wires.jpg": 67966,
	"./content/bg-wires/bg-wires.webp": 9620,
	"./content/bg-zappi/bg-zappi--mobile.jpg": 48805,
	"./content/bg-zappi/bg-zappi--mobile.webp": 3560,
	"./content/bg-zappi/bg-zappi.jpg": 28915,
	"./content/bg-zappi/bg-zappi.webp": 36841,
	"./content/career-perks-1/career-perks-1.png": 33386,
	"./content/career-perks-1/career-perks-1.webp": 35271,
	"./content/career-perks-2/career-perks-2.png": 45839,
	"./content/career-perks-2/career-perks-2.webp": 34255,
	"./content/career-perks-3/career-perks-3.png": 28374,
	"./content/career-perks-3/career-perks-3.webp": 30505,
	"./content/career-perks-4/career-perks-4.png": 23346,
	"./content/career-perks-4/career-perks-4.webp": 44024,
	"./content/chess/chess--mobile.jpg": 99836,
	"./content/chess/chess--mobile.webp": 61887,
	"./content/chess/chess.jpg": 60377,
	"./content/chess/chess.webp": 17653,
	"./content/client-video-embed-placeholder/client-video-embed-placeholder.png": 26682,
	"./content/client-video-embed-placeholder/client-video-embed-placeholder.webp": 721,
	"./content/comparisons-app-creation/comparisons-app-creation--mobile.png": 9136,
	"./content/comparisons-app-creation/comparisons-app-creation--mobile.webp": 87317,
	"./content/comparisons-app-creation/comparisons-app-creation.gif": 8804,
	"./content/comparisons-app-creation/comparisons-app-creation.png": 45643,
	"./content/comparisons-app-creation/comparisons-app-creation.webp": 52568,
	"./content/comparisons-automl-results/comparisons-automl-results.png": 75316,
	"./content/comparisons-automl-results/comparisons-automl-results.webp": 51318,
	"./content/comparisons-breadth-features/comparisons-breadth-features.png": 22106,
	"./content/comparisons-breadth-features/comparisons-breadth-features.webp": 76718,
	"./content/comparisons-control-transparency/comparisons-control-transparency.png": 83280,
	"./content/comparisons-control-transparency/comparisons-control-transparency.webp": 9169,
	"./content/comparisons-eda/comparisons-eda.png": 28616,
	"./content/comparisons-eda/comparisons-eda.webp": 85233,
	"./content/comparisons-feature-engineering/comparisons-feature-engineering.png": 55744,
	"./content/comparisons-feature-engineering/comparisons-feature-engineering.webp": 77214,
	"./content/comparisons-mission-critical/comparisons-mission-critical.png": 69637,
	"./content/comparisons-mission-critical/comparisons-mission-critical.webp": 15195,
	"./content/comparisons-model-explain/comparisons-model-explain.png": 77353,
	"./content/comparisons-model-explain/comparisons-model-explain.webp": 27668,
	"./content/comparisons-team/comparisons-team--mobile.jpg": 53646,
	"./content/comparisons-team/comparisons-team--mobile.webp": 59792,
	"./content/comparisons-team/comparisons-team.jpg": 61674,
	"./content/comparisons-team/comparisons-team.webp": 56823,
	"./content/cs-deloitte/cs-deloitte--mobile.png": 58986,
	"./content/cs-deloitte/cs-deloitte--mobile.webp": 23033,
	"./content/cs-deloitte/cs-deloitte.png": 1933,
	"./content/cs-deloitte/cs-deloitte.webp": 78877,
	"./content/cs-email-automation/cs-email-automation--mobile.jpg": 4747,
	"./content/cs-email-automation/cs-email-automation--mobile.webp": 62549,
	"./content/cs-email-automation/cs-email-automation.jpg": 71248,
	"./content/cs-email-automation/cs-email-automation.webp": 66159,
	"./content/cs-solution-architecture/cs-solution-architecture--mobile.png": 26728,
	"./content/cs-solution-architecture/cs-solution-architecture--mobile.webp": 29520,
	"./content/cs-solution-architecture/cs-solution-architecture.png": 86442,
	"./content/cs-solution-architecture/cs-solution-architecture.webp": 78565,
	"./content/data-about-screenshot-1/data-about-screenshot-1--mobile.png": 46403,
	"./content/data-about-screenshot-1/data-about-screenshot-1--mobile.webp": 52814,
	"./content/data-about-screenshot-1/data-about-screenshot-1.png": 26832,
	"./content/data-about-screenshot-1/data-about-screenshot-1.webp": 31020,
	"./content/data-about-screenshot-2/data-about-screenshot-2--mobile.png": 49666,
	"./content/data-about-screenshot-2/data-about-screenshot-2--mobile.webp": 37005,
	"./content/data-about-screenshot-2/data-about-screenshot-2.png": 44664,
	"./content/data-about-screenshot-2/data-about-screenshot-2.webp": 55362,
	"./content/data-about-screenshot-3/data-about-screenshot-3--mobile.png": 8856,
	"./content/data-about-screenshot-3/data-about-screenshot-3--mobile.webp": 22856,
	"./content/data-about-screenshot-3/data-about-screenshot-3.png": 28494,
	"./content/data-about-screenshot-3/data-about-screenshot-3.webp": 31480,
	"./content/data-about-thumbnail-1/data-about-thumbnail-1.svg": 80354,
	"./content/data-about-thumbnail-2/data-about-thumbnail-2.svg": 69220,
	"./content/data-about-thumbnail-3/data-about-thumbnail-3.svg": 89952,
	"./content/data-free-for-beta-mobile/data-free-for-beta-mobile.png": 12654,
	"./content/data-free-for-beta-mobile/data-free-for-beta-mobile.webp": 82859,
	"./content/data-free-for-beta/data-free-for-beta.png": 271,
	"./content/data-free-for-beta/data-free-for-beta.webp": 87464,
	"./content/data-more-about-img/data-more-about-img--mobile.png": 16237,
	"./content/data-more-about-img/data-more-about-img--mobile.webp": 76401,
	"./content/data-more-about-img/data-more-about-img.png": 46454,
	"./content/data-more-about-img/data-more-about-img.webp": 14349,
	"./content/data-more-about-img2/data-more-about-img2--mobile.png": 60451,
	"./content/data-more-about-img2/data-more-about-img2--mobile.webp": 4263,
	"./content/data-more-about-img2/data-more-about-img2.png": 70696,
	"./content/data-more-about-img2/data-more-about-img2.webp": 12315,
	"./content/data-more-about-img3/data-more-about-img3--mobile.png": 82411,
	"./content/data-more-about-img3/data-more-about-img3--mobile.webp": 59703,
	"./content/data-more-about-img3/data-more-about-img3.png": 99045,
	"./content/data-more-about-img3/data-more-about-img3.webp": 89038,
	"./content/data-quote-simon-james/data-quote-simon-james--mobile.png": 53222,
	"./content/data-quote-simon-james/data-quote-simon-james--mobile.webp": 67292,
	"./content/data-quote-simon-james/data-quote-simon-james.png": 39377,
	"./content/data-quote-simon-james/data-quote-simon-james.webp": 93850,
	"./content/feature-importances-long/feature-importances-long--mobile.png": 36631,
	"./content/feature-importances-long/feature-importances-long--mobile.webp": 95643,
	"./content/feature-importances-long/feature-importances-long.png": 3181,
	"./content/feature-importances-long/feature-importances-long.webp": 23806,
	"./content/feature-importances-sales/feature-importances-sales--mobile.png": 92900,
	"./content/feature-importances-sales/feature-importances-sales--mobile.webp": 52147,
	"./content/feature-importances-sales/feature-importances-sales.png": 19969,
	"./content/feature-importances-sales/feature-importances-sales.webp": 75533,
	"./content/feature-importances/feature-importances--mobile.png": 54550,
	"./content/feature-importances/feature-importances--mobile.webp": 5067,
	"./content/feature-importances/feature-importances.png": 21401,
	"./content/feature-importances/feature-importances.webp": 87726,
	"./content/form-thank-you-smiley/form-thank-you-smiley--mobile.png": 32222,
	"./content/form-thank-you-smiley/form-thank-you-smiley--mobile.webp": 73159,
	"./content/form-thank-you-smiley/form-thank-you-smiley.png": 66483,
	"./content/form-thank-you-smiley/form-thank-you-smiley.webp": 86992,
	"./content/gs-1-upload/gs-1-upload--mobile.jpg": 42794,
	"./content/gs-1-upload/gs-1-upload--mobile.webp": 38934,
	"./content/gs-1-upload/gs-1-upload.jpg": 92673,
	"./content/gs-1-upload/gs-1-upload.webp": 32317,
	"./content/gs-2-target/gs-2-target--mobile.jpg": 99047,
	"./content/gs-2-target/gs-2-target--mobile.webp": 88173,
	"./content/gs-2-target/gs-2-target.jpg": 2077,
	"./content/gs-2-target/gs-2-target.webp": 23396,
	"./content/gs-2b-reviewgeneratedcode/gs-2b-reviewgeneratedcode--mobile.jpg": 57956,
	"./content/gs-2b-reviewgeneratedcode/gs-2b-reviewgeneratedcode--mobile.webp": 70152,
	"./content/gs-2b-reviewgeneratedcode/gs-2b-reviewgeneratedcode.jpg": 90446,
	"./content/gs-2b-reviewgeneratedcode/gs-2b-reviewgeneratedcode.webp": 23904,
	"./content/gs-3-publishmodel/gs-3-publishmodel--mobile.jpg": 97086,
	"./content/gs-3-publishmodel/gs-3-publishmodel--mobile.webp": 87529,
	"./content/gs-3-publishmodel/gs-3-publishmodel.jpg": 68594,
	"./content/gs-3-publishmodel/gs-3-publishmodel.webp": 72138,
	"./content/gs-4-copysnidbit/gs-4-copysnidbit--mobile.jpg": 81690,
	"./content/gs-4-copysnidbit/gs-4-copysnidbit--mobile.webp": 80361,
	"./content/gs-4-copysnidbit/gs-4-copysnidbit.jpg": 22994,
	"./content/gs-4-copysnidbit/gs-4-copysnidbit.webp": 6128,
	"./content/gs-5-businessvalue/gs-5-businessvalue--mobile.jpg": 73670,
	"./content/gs-5-businessvalue/gs-5-businessvalue--mobile.webp": 62891,
	"./content/gs-5-businessvalue/gs-5-businessvalue.jpg": 82575,
	"./content/gs-5-businessvalue/gs-5-businessvalue.webp": 75760,
	"./content/gs-6-explainmodel/gs-6-explainmodel--mobile.jpg": 12808,
	"./content/gs-6-explainmodel/gs-6-explainmodel--mobile.webp": 31109,
	"./content/gs-6-explainmodel/gs-6-explainmodel.jpg": 1389,
	"./content/gs-6-explainmodel/gs-6-explainmodel.webp": 59237,
	"./content/gs-8-deploymodel/gs-8-deploymodel--mobile.jpg": 44614,
	"./content/gs-8-deploymodel/gs-8-deploymodel--mobile.webp": 56716,
	"./content/gs-8-deploymodel/gs-8-deploymodel.jpg": 41061,
	"./content/gs-8-deploymodel/gs-8-deploymodel.webp": 52014,
	"./content/gs-R-code/gs-R-code--mobile.png": 11303,
	"./content/gs-R-code/gs-R-code--mobile.webp": 58226,
	"./content/gs-R-code/gs-R-code.png": 24295,
	"./content/gs-R-code/gs-R-code.webp": 88862,
	"./content/gs-full-solution/gs-full-solution.svg": 13905,
	"./content/gs-python-code/gs-python-code--mobile.png": 98547,
	"./content/gs-python-code/gs-python-code--mobile.webp": 42883,
	"./content/gs-python-code/gs-python-code.png": 75095,
	"./content/gs-python-code/gs-python-code.webp": 88429,
	"./content/gs-self-service/gs-self-service.svg": 56526,
	"./content/icon-andy-signature/icon-andy-signature--mobile.png": 28162,
	"./content/icon-andy-signature/icon-andy-signature--mobile.webp": 13927,
	"./content/icon-andy-signature/icon-andy-signature.png": 42001,
	"./content/icon-andy-signature/icon-andy-signature.webp": 78144,
	"./content/img-app-deployment/img-app-deployment--mobile.jpg": 31482,
	"./content/img-app-deployment/img-app-deployment--mobile.webp": 63492,
	"./content/img-app-deployment/img-app-deployment.jpg": 68273,
	"./content/img-app-deployment/img-app-deployment.webp": 15018,
	"./content/img-app-explain/img-app-explain--mobile.jpg": 15673,
	"./content/img-app-explain/img-app-explain--mobile.webp": 37080,
	"./content/img-app-explain/img-app-explain.jpg": 19008,
	"./content/img-app-explain/img-app-explain.webp": 78966,
	"./content/img-app-graphs/img-app-graphs--mobile.jpg": 59486,
	"./content/img-app-graphs/img-app-graphs--mobile.webp": 84564,
	"./content/img-app-graphs/img-app-graphs.jpg": 73305,
	"./content/img-app-graphs/img-app-graphs.webp": 75455,
	"./content/img-app-leaderboard/img-app-leaderboard--mobile.jpg": 34343,
	"./content/img-app-leaderboard/img-app-leaderboard--mobile.webp": 94839,
	"./content/img-app-leaderboard/img-app-leaderboard.jpg": 7825,
	"./content/img-app-leaderboard/img-app-leaderboard.webp": 44021,
	"./content/img-app-pension/img-app-pension--mobile.png": 7549,
	"./content/img-app-pension/img-app-pension--mobile.webp": 40904,
	"./content/img-app-pension/img-app-pension.png": 41516,
	"./content/img-app-pension/img-app-pension.webp": 14335,
	"./content/img-app-training/img-app-training--mobile.jpg": 72929,
	"./content/img-app-training/img-app-training--mobile.webp": 14031,
	"./content/img-app-training/img-app-training.jpg": 89426,
	"./content/img-app-training/img-app-training.webp": 41851,
	"./content/img-art-pandas-profiling-1/img-art-pandas-profiling-1.png": 65061,
	"./content/img-art-pandas-profiling-1/img-art-pandas-profiling-1.webp": 30453,
	"./content/img-art-pandas-profiling-10/img-art-pandas-profiling-10.png": 35537,
	"./content/img-art-pandas-profiling-10/img-art-pandas-profiling-10.webp": 66704,
	"./content/img-art-pandas-profiling-11/img-art-pandas-profiling-11.png": 83382,
	"./content/img-art-pandas-profiling-11/img-art-pandas-profiling-11.webp": 43675,
	"./content/img-art-pandas-profiling-2/img-art-pandas-profiling-2.png": 54042,
	"./content/img-art-pandas-profiling-2/img-art-pandas-profiling-2.webp": 7551,
	"./content/img-art-pandas-profiling-3/img-art-pandas-profiling-3.png": 17494,
	"./content/img-art-pandas-profiling-3/img-art-pandas-profiling-3.webp": 13950,
	"./content/img-art-pandas-profiling-4/img-art-pandas-profiling-4.png": 75282,
	"./content/img-art-pandas-profiling-4/img-art-pandas-profiling-4.webp": 16002,
	"./content/img-art-pandas-profiling-5/img-art-pandas-profiling-5.png": 17523,
	"./content/img-art-pandas-profiling-5/img-art-pandas-profiling-5.webp": 32062,
	"./content/img-art-pandas-profiling-6/img-art-pandas-profiling-6.png": 58145,
	"./content/img-art-pandas-profiling-6/img-art-pandas-profiling-6.webp": 50942,
	"./content/img-art-pandas-profiling-7/img-art-pandas-profiling-7.png": 77568,
	"./content/img-art-pandas-profiling-7/img-art-pandas-profiling-7.webp": 69304,
	"./content/img-art-pandas-profiling-8/img-art-pandas-profiling-8.png": 28722,
	"./content/img-art-pandas-profiling-8/img-art-pandas-profiling-8.webp": 8696,
	"./content/img-art-pandas-profiling-9/img-art-pandas-profiling-9.png": 42292,
	"./content/img-art-pandas-profiling-9/img-art-pandas-profiling-9.webp": 1683,
	"./content/img-asaas/img-asaas--mobile.png": 95942,
	"./content/img-asaas/img-asaas--mobile.webp": 43346,
	"./content/img-asaas/img-asaas.png": 31933,
	"./content/img-asaas/img-asaas.webp": 28628,
	"./content/img-credit-score-benefit/img-credit-score-benefit--mobile.jpg": 76696,
	"./content/img-credit-score-benefit/img-credit-score-benefit--mobile.webp": 99492,
	"./content/img-credit-score-benefit/img-credit-score-benefit.jpg": 56273,
	"./content/img-credit-score-benefit/img-credit-score-benefit.webp": 36621,
	"./content/img-credit-score-old-vs-new/img-credit-score-old-vs-new--mobile.jpg": 1076,
	"./content/img-credit-score-old-vs-new/img-credit-score-old-vs-new--mobile.webp": 80661,
	"./content/img-credit-score-old-vs-new/img-credit-score-old-vs-new.jpg": 51116,
	"./content/img-credit-score-old-vs-new/img-credit-score-old-vs-new.webp": 52882,
	"./content/img-cs-zappi-timeline/img-cs-zappi-timeline--mobile.png": 89090,
	"./content/img-cs-zappi-timeline/img-cs-zappi-timeline--mobile.webp": 89839,
	"./content/img-cs-zappi-timeline/img-cs-zappi-timeline.png": 58811,
	"./content/img-cs-zappi-timeline/img-cs-zappi-timeline.webp": 62113,
	"./content/img-data-prep-preview/img-data-prep-preview--mobile.png": 1236,
	"./content/img-data-prep-preview/img-data-prep-preview--mobile.webp": 71511,
	"./content/img-data-prep-preview/img-data-prep-preview.png": 35737,
	"./content/img-data-prep-preview/img-data-prep-preview.webp": 9238,
	"./content/img-kortical-timeline/img-kortical-timeline--mobile.png": 18340,
	"./content/img-kortical-timeline/img-kortical-timeline--mobile.webp": 10323,
	"./content/img-kortical-timeline/img-kortical-timeline.png": 49341,
	"./content/img-kortical-timeline/img-kortical-timeline.webp": 24461,
	"./content/img-ml-vs-programming/img-ml-vs-programming--mobile.png": 93009,
	"./content/img-ml-vs-programming/img-ml-vs-programming--mobile.webp": 39135,
	"./content/img-ml-vs-programming/img-ml-vs-programming.png": 93465,
	"./content/img-ml-vs-programming/img-ml-vs-programming.webp": 16964,
	"./content/img-nhs-app/img-nhs-app--mobile.jpg": 74549,
	"./content/img-nhs-app/img-nhs-app--mobile.webp": 2124,
	"./content/img-nhs-app/img-nhs-app.jpg": 13130,
	"./content/img-nhs-app/img-nhs-app.webp": 59007,
	"./content/img-nhs-kortical/img-nhs-kortical--mobile.jpg": 87866,
	"./content/img-nhs-kortical/img-nhs-kortical--mobile.webp": 61907,
	"./content/img-nhs-kortical/img-nhs-kortical.jpg": 58570,
	"./content/img-nhs-kortical/img-nhs-kortical.webp": 3813,
	"./content/img-nhs-optimiser/img-nhs-optimiser--mobile.jpg": 91615,
	"./content/img-nhs-optimiser/img-nhs-optimiser--mobile.webp": 95406,
	"./content/img-nhs-optimiser/img-nhs-optimiser.jpg": 94520,
	"./content/img-nhs-optimiser/img-nhs-optimiser.webp": 55354,
	"./content/img-nhs-platelet-supply-chain/img-nhs-platelet-supply-chain--mobile.jpg": 6569,
	"./content/img-nhs-platelet-supply-chain/img-nhs-platelet-supply-chain--mobile.webp": 98698,
	"./content/img-nhs-platelet-supply-chain/img-nhs-platelet-supply-chain.jpg": 65900,
	"./content/img-nhs-platelet-supply-chain/img-nhs-platelet-supply-chain.webp": 119,
	"./content/img-nhs-platform/img-nhs-platform.gif": 57134,
	"./content/img-nhs-process/img-nhs-process--mobile.png": 46413,
	"./content/img-nhs-process/img-nhs-process--mobile.webp": 94174,
	"./content/img-nhs-process/img-nhs-process.png": 29186,
	"./content/img-nhs-process/img-nhs-process.webp": 32707,
	"./content/img-platform-explain/img-platform-explain--mobile.png": 13405,
	"./content/img-platform-explain/img-platform-explain--mobile.webp": 53757,
	"./content/img-platform-explain/img-platform-explain.png": 30404,
	"./content/img-platform-explain/img-platform-explain.webp": 63368,
	"./content/img-schroders-distribution-datathon/img-schroders-distribution-datathon--mobile.png": 75357,
	"./content/img-schroders-distribution-datathon/img-schroders-distribution-datathon--mobile.webp": 6397,
	"./content/img-schroders-distribution-datathon/img-schroders-distribution-datathon.png": 48828,
	"./content/img-schroders-distribution-datathon/img-schroders-distribution-datathon.webp": 68379,
	"./content/img-tac-graph/img-tac-graph--mobile.png": 35031,
	"./content/img-tac-graph/img-tac-graph--mobile.webp": 43784,
	"./content/img-tac-graph/img-tac-graph.png": 23994,
	"./content/img-tac-graph/img-tac-graph.webp": 32849,
	"./content/img-what-is-ml/img-what-is-ml--mobile.png": 98643,
	"./content/img-what-is-ml/img-what-is-ml--mobile.webp": 29087,
	"./content/img-what-is-ml/img-what-is-ml.png": 16944,
	"./content/img-what-is-ml/img-what-is-ml.webp": 46641,
	"./content/innovator-1/innovator-1--mobile.png": 54698,
	"./content/innovator-1/innovator-1--mobile.webp": 63474,
	"./content/innovator-1/innovator-1.png": 93938,
	"./content/innovator-1/innovator-1.webp": 69746,
	"./content/intelligent-automation-1/intelligent-automation-1--mobile.png": 28138,
	"./content/intelligent-automation-1/intelligent-automation-1--mobile.webp": 41640,
	"./content/intelligent-automation-1/intelligent-automation-1.png": 51294,
	"./content/intelligent-automation-1/intelligent-automation-1.webp": 98346,
	"./content/intelligent-automation-2/intelligent-automation-2.png": 92339,
	"./content/intelligent-automation-2/intelligent-automation-2.webp": 48520,
	"./content/inventory-optimisation-1/inventory-optimisation-1--mobile.png": 30754,
	"./content/inventory-optimisation-1/inventory-optimisation-1--mobile.webp": 53041,
	"./content/inventory-optimisation-1/inventory-optimisation-1.png": 26518,
	"./content/inventory-optimisation-1/inventory-optimisation-1.webp": 87342,
	"./content/inventory-optimisation-2/inventory-optimisation-2--mobile.png": 59053,
	"./content/inventory-optimisation-2/inventory-optimisation-2--mobile.webp": 93528,
	"./content/inventory-optimisation-2/inventory-optimisation-2.png": 29491,
	"./content/inventory-optimisation-2/inventory-optimisation-2.webp": 57813,
	"./content/key-brains/key-brain--blue.png": 55520,
	"./content/key-brains/key-brain--blue.webp": 29257,
	"./content/key-brains/key-brain--green.png": 92949,
	"./content/key-brains/key-brain--green.webp": 52107,
	"./content/key-brains/key-brain--pink.png": 72245,
	"./content/key-brains/key-brain--pink.webp": 80721,
	"./content/key-brains/key-brain--yellow.png": 85475,
	"./content/key-brains/key-brain--yellow.webp": 95292,
	"./content/lego-unicorn-man/lego-unicorn-man--mobile.jpg": 58571,
	"./content/lego-unicorn-man/lego-unicorn-man--mobile.webp": 44863,
	"./content/lego-unicorn-man/lego-unicorn-man.jpg": 39345,
	"./content/lego-unicorn-man/lego-unicorn-man.webp": 21351,
	"./content/og-black-box/og-black-box.jpg": 7206,
	"./content/og-bt/og-bt.jpg": 52862,
	"./content/og-credit-score/og-credit-score.jpg": 28552,
	"./content/og-default/og-default.jpg": 39407,
	"./content/og-deloitte/og-deloitte.jpg": 44723,
	"./content/og-hackathon-4/og-hackathon-4.jpg": 94310,
	"./content/og-hackathon-5/og-hackathon-5.jpg": 47839,
	"./content/og-months/og-months.jpg": 14940,
	"./content/og-myth-citzen-data-scientist/og-myth-citzen-data-scientist.jpg": 68140,
	"./content/og-nhs/og-nhs.jpg": 15395,
	"./content/og-pandas-profiling/og-pandas-profiling.png": 77900,
	"./content/og-publicis/og-publicis.jpg": 36992,
	"./content/og-rejecting-automl/og-rejecting-automl.jpg": 41810,
	"./content/og-tac/og-tac.jpg": 74112,
	"./content/og-zappi/og-zappi.jpg": 34733,
	"./content/platform-uses/platform-uses.svg": 78996,
	"./content/platform-uses/platform-uses_mobile.svg": 30562,
	"./content/podcasts-hero/podcasts-hero--mobile.png": 42669,
	"./content/podcasts-hero/podcasts-hero--mobile.webp": 55351,
	"./content/podcasts-hero/podcasts-hero.png": 5532,
	"./content/podcasts-hero/podcasts-hero.webp": 36031,
	"./content/predicting-failures/predicting-failures--mobile.png": 91050,
	"./content/predicting-failures/predicting-failures--mobile.webp": 49894,
	"./content/predicting-failures/predicting-failures.png": 91123,
	"./content/predicting-failures/predicting-failures.webp": 6311,
	"./content/preview-platform/preview-platform.gif": 50782,
	"./content/preview-platform/preview-platform.mp4": 14086,
	"./content/preview-platform/preview-platform.png": 25482,
	"./content/preview-platform/preview-platform.webp": 44630,
	"./content/reed-1/reed-1--mobile.jpg": 89154,
	"./content/reed-1/reed-1--mobile.webp": 55571,
	"./content/reed-1/reed-1.jpg": 48673,
	"./content/reed-1/reed-1.webp": 62732,
	"./content/reed-2/reed-2--mobile.png": 48578,
	"./content/reed-2/reed-2--mobile.webp": 86820,
	"./content/reed-2/reed-2.png": 28978,
	"./content/reed-2/reed-2.webp": 35509,
	"./content/reed-3/reed-3--mobile.png": 63991,
	"./content/reed-3/reed-3--mobile.webp": 2958,
	"./content/reed-3/reed-3.png": 2552,
	"./content/reed-3/reed-3.webp": 74672,
	"./content/reed-4/reed-4--mobile.png": 40337,
	"./content/reed-4/reed-4--mobile.webp": 79607,
	"./content/reed-4/reed-4.png": 22535,
	"./content/reed-4/reed-4.webp": 39136,
	"./content/reed-5/reed-5.png": 43639,
	"./content/reed-5/reed-5.webp": 67886,
	"./content/screenshot-actions/screenshot-actions--mobile.png": 57297,
	"./content/screenshot-actions/screenshot-actions--mobile.webp": 2313,
	"./content/screenshot-actions/screenshot-actions.png": 40852,
	"./content/screenshot-actions/screenshot-actions.webp": 57862,
	"./content/screenshot-feature-importances/screenshot-feature-importances--mobile.png": 49572,
	"./content/screenshot-feature-importances/screenshot-feature-importances--mobile.webp": 47441,
	"./content/screenshot-feature-importances/screenshot-feature-importances.png": 54045,
	"./content/screenshot-feature-importances/screenshot-feature-importances.webp": 29224,
	"./content/screenshot-target-scores/screenshot-target-scores--mobile.png": 92737,
	"./content/screenshot-target-scores/screenshot-target-scores--mobile.webp": 55263,
	"./content/screenshot-target-scores/screenshot-target-scores.png": 8716,
	"./content/screenshot-target-scores/screenshot-target-scores.webp": 25802,
	"./content/screenshot-timeseries-chart/screenshot-timeseries-chart--mobile.png": 6956,
	"./content/screenshot-timeseries-chart/screenshot-timeseries-chart--mobile.webp": 60982,
	"./content/screenshot-timeseries-chart/screenshot-timeseries-chart.png": 53461,
	"./content/screenshot-timeseries-chart/screenshot-timeseries-chart.webp": 90637,
	"./content/superhuman-ai-1/superhuman-ai-1.png": 76887,
	"./content/superhuman-ai-1/superhuman-ai-1.webp": 60460,
	"./content/superhuman-ai/superhuman-ai.png": 45832,
	"./content/superhuman-ai/superhuman-ai.webp": 1232,
	"./content/tech-nation-1/tech-nation-1--mobile.png": 51784,
	"./content/tech-nation-1/tech-nation-1--mobile.webp": 78270,
	"./content/tech-nation-1/tech-nation-1.png": 20118,
	"./content/tech-nation-1/tech-nation-1.webp": 70094,
	"./content/tech-nation-2/tech-nation-2.png": 83243,
	"./content/tech-nation-2/tech-nation-2.webp": 76870,
	"./content/unicorn-lego-man/unicorn-lego-man--mobile.jpg": 34939,
	"./content/unicorn-lego-man/unicorn-lego-man--mobile.webp": 45334,
	"./content/unicorn-lego-man/unicorn-lego-man.jpg": 38132,
	"./content/unicorn-lego-man/unicorn-lego-man.webp": 84037,
	"./content/video-placeholder/video-placeholder.jpg": 5498,
	"./content/video-placeholder/video-placeholder.webp": 24172,
	"./content/why-ml-10/why-ml-10--mobile.png": 65631,
	"./content/why-ml-10/why-ml-10--mobile.webp": 40077,
	"./content/why-ml-10/why-ml-10.png": 48219,
	"./content/why-ml-10/why-ml-10.webp": 47113,
	"./content/why-ml-3/why-ml-3--mobile.jpg": 42922,
	"./content/why-ml-3/why-ml-3--mobile.webp": 82767,
	"./content/why-ml-3/why-ml-3.jpg": 88848,
	"./content/why-ml-3/why-ml-3.webp": 373,
	"./content/why-ml-9/why-ml-9.jpg": 30962,
	"./content/why-ml-9/why-ml-9.webp": 73548,
	"./content/woman-developer-thinking/woman-developer-thinking--mobile.jpg": 32576,
	"./content/woman-developer-thinking/woman-developer-thinking--mobile.webp": 74066,
	"./content/woman-developer-thinking/woman-developer-thinking.jpg": 44742,
	"./content/woman-developer-thinking/woman-developer-thinking.webp": 63735,
	"./favicon/kortical-icon.png": 24980,
	"./icons/down-arrow--thin.svg": 35462,
	"./icons/down-arrow.svg": 89103,
	"./icons/down-arrow.svg.js": 89103,
	"./icons/icon-autoML-spinner.svg": 10821,
	"./icons/icon-brain-black.svg": 9565,
	"./icons/icon-build.svg": 94915,
	"./icons/icon-bullet-check.svg": 97247,
	"./icons/icon-check--pink.svg": 96957,
	"./icons/icon-check.svg": 83449,
	"./icons/icon-checkmark.svg": 17034,
	"./icons/icon-code.svg": 15852,
	"./icons/icon-comparison-check.svg": 60144,
	"./icons/icon-cs-automation.svg": 54688,
	"./icons/icon-cs-cg.svg": 61575,
	"./icons/icon-cs-finance.svg": 45069,
	"./icons/icon-cs-health.svg": 49057,
	"./icons/icon-cs-manufacturing.svg": 79492,
	"./icons/icon-cs-marketing.svg": 64595,
	"./icons/icon-cs-retail.svg": 75537,
	"./icons/icon-cs-sustainability.svg.svg": 27291,
	"./icons/icon-cs-telecoms.svg": 85202,
	"./icons/icon-cs-transformation.svg": 75765,
	"./icons/icon-deploy.svg": 81306,
	"./icons/icon-empowering.svg": 84359,
	"./icons/icon-facebook--sitemap.svg": 34779,
	"./icons/icon-facebook-dark.svg": 36028,
	"./icons/icon-faster.svg": 99601,
	"./icons/icon-full-autoML-default.svg": 40975,
	"./icons/icon-full-autoML-missing-spinner.svg": 18033,
	"./icons/icon-instagram--sitemap.svg": 25156,
	"./icons/icon-link.svg": 53003,
	"./icons/icon-linkedin--sitemap.svg": 36402,
	"./icons/icon-linkedin-color.svg": 47104,
	"./icons/icon-linkedin.svg": 39142,
	"./icons/icon-models.svg": 57809,
	"./icons/icon-play.svg": 39346,
	"./icons/icon-quotemark.svg": 72494,
	"./icons/icon-quotes.svg": 74250,
	"./icons/icon-twitter--colored.svg": 78670,
	"./icons/icon-twitter--sitemap.svg": 1553,
	"./icons/icon-twitter-dark.svg": 6331,
	"./icons/icon-twitter.svg": 59843,
	"./icons/icon-v-pause.svg": 66148,
	"./icons/icon-v-play.svg": 95300,
	"./icons/icon-value.svg": 71592,
	"./icons/icon_ai.svg": 53553,
	"./icons/icon_apps.svg": 94691,
	"./layout/bg-circles.svg": 61604,
	"./layout/bg-client-video-stripes.svg": 18144,
	"./layout/bg-data-prep-stripes.svg": 16884,
	"./layout/bg-data-prep-stripes2.svg": 48724,
	"./layout/bg-demo-stripes.svg": 68513,
	"./layout/bg-diamond--blue.svg": 43109,
	"./layout/bg-diamond-filled.svg": 25248,
	"./layout/bg-diamond.svg": 25789,
	"./layout/bg-gs-stripes.svg": 43818,
	"./layout/bg-hexagon-filled.svg": 65662,
	"./layout/bg-hexagon-stripes.svg": 1172,
	"./layout/bg-landing-page-stripes.svg": 64802,
	"./layout/bg-nav-stripes.svg": 92349,
	"./layout/bg-platform-video-stripes.svg": 61194,
	"./layout/bg-practice-points-stripes.svg": 53009,
	"./layout/bg-stat-loader-stripes.svg": 40155,
	"./logos/kortical-LGBT.svg": 38041,
	"./logos/kortical-logo.svg": 75292
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 96303;